// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import updateLoadParameter from "@adl/App/Handlers/CustomQuote/UpdateLoadParameters";
import { CustomAppState } from "@adl/App/Store/Reducers";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import DynamicDropdown, { OptionObject } from "@insite/mobius/DynamicDropdown";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";

interface OwnProps extends WidgetProps {}

const mapStateToProps = (state: CustomAppState) => {
    return {
        pagination: state.xMyCustomQuotes.pagination,
        currentSortOption: state.xMyCustomQuotes.pagination.sortType,
    };
};

const mapDispatchToProps = {
    updateLoadParameter,
};

type Props = OwnProps & ResolveThunks<typeof mapDispatchToProps> & ReturnType<typeof mapStateToProps>;

export interface MyListsSortControlStyles {
    wrapper?: InjectableCss;
}

export const sortControlStyles: MyListsSortControlStyles = {};

const styles = sortControlStyles;

const MyCustomQuotesSortControl = ({ currentSortOption, updateLoadParameter, pagination }: Props) => {
    const [sortOptions, setSortOptions] = useState<OptionObject[]>([]);
    useEffect(() => {
        setSortOptions(
            pagination?.sortOptions?.map((o: { displayName: any; sortType: any }) => ({
                optionText: o.displayName,
                optionValue: o.sortType,
            })),
        );
    }, [pagination]);

    const sortChangeHandler = (value?: string) => {
        updateLoadParameter({ sort: value });
    };

    return (
        <StyledWrapper {...styles.wrapper}>
            {sortOptions && (
                <DynamicDropdown
                    data-test-selector="myCustomQuotes_sortControl"
                    options={sortOptions}
                    selected={currentSortOption}
                    onSelectionChange={sortChangeHandler}
                />
            )}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(MyCustomQuotesSortControl),
    definition: {
        group: "Custom Quote" as any,
        displayName: "Sort Control",
        allowedContexts: ["CustomQuotesPage" as any],
    },
};

export default widgetModule;
